"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var constants_1 = require("@hikakaku/shared/constants");
var SubmitButton = function (_a) {
    var text = _a.text, className = _a.className, disabled = _a.disabled, onClick = _a.onClick;
    return (react_1.default.createElement("div", { className: "estimateForm-SubmitPageFooter_SubmitButtonWrapper" },
        react_1.default.createElement("button", { disabled: disabled, onClick: onClick, className: className }, text),
        react_1.default.createElement("div", { className: "estimateForm-SubmitPageFooter_Term" },
            "\u7533\u8FBC\u3068\u540C\u6642\u306B",
            react_1.default.createElement("a", { target: "_blank", rel: "noreferrer", href: constants_1.PATH.SERVICE_TERM }, "\u5229\u7528\u898F\u7D04"),
            "\u306B\u540C\u610F\u3057\u305F\u6271\u3044\u3068\u3057\u307E\u3059\u3002")));
};
exports.default = SubmitButton;
